/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  gs,
//  BarC,
  BoxC,
  HtyC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  GridC,
  _cv_51___Ci,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _cv_51___Ci from "./_cv_51___Ci";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
/*
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
*/
                  cr.c(HtyC.N, {
                    key: -10,
                    sPz: pz.sPz,
                    cz: {
                      elm: '_51r',
                      cdn: `_icn = '${pz.sPz.crt._50r_icn}'`
//                        _fst: pz.sPz.crt.i15r_fst,
                    }
                  })
                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(_cv_51___Ci.D, {
                  key: -10,
                  sPz: pz.sPz,
                  cz: {
//                    cdn: `_51r_31r1f=${_gUserz.crt._31rz._fst}`,
                    _31r_fst: _gUserz.crt._31rz._fst,
                  }
                }),

              ],
            }),

            cr.c(_cv_51___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
              },
            }),

          ]
        })

      ]
    })
  );
};
